export default class Common {
    public static isNullOrWhiteSpace(value: string) {
        return value === null || value?.toString().match(/^ *$/) !== null;
    }

    public static newGuid(): string {
        return crypto.randomUUID();
    }

    public static escapeHtml(unescapedHtml: string) {
        return unescapedHtml
            ?.replace(/&/g, "&amp;")
            ?.replace(/</g, "&lt;")
            ?.replace(/>/g, "&gt;")
            ?.replace(/"/g, "&quot;")
            ?.replace(/'/g, "&#039;");
    }

    public static unescapeHtml(escapedHtml: string) {
        return escapedHtml
            ?.replace(/&lt;/g, "<")
            ?.replace(/&gt;/g, ">")
            ?.replace(/&quot;/g, '"')
            ?.replace(/&#039;/g, "'")
            ?.replace(/&amp;/g, "&");
    }
}
